<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      <el-breadcrumb-item>供应商价格档案</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <el-card class="box-card">
          <!-- 筛选条件 start -->
          <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
            <el-form-item label="">
              <el-input v-model="keywords.bomname" @keyup.enter.native="clicksearch" placeholder="请输入材料名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.suppliername" @keyup.enter.native="clicksearch" placeholder="请输入供应商名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="keywords.contactname" @keyup.enter.native="clicksearch" placeholder="请输入供应商联系人"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksearch">查询</el-button>
              <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
              <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
              注意：此处是覆盖导入
            </el-form-item>
          </el-form>
          <!-- 筛选条件 end -->

          <!-- 数据列表 start -->
          <el-table v-loading="loading" :data="dataList" ref="dataList" :cell-style="{padding: '0'}" border height="440">
            <el-table-column prop="Companyname" label="所属公司名称" width="220"></el-table-column>
            <el-table-column prop="Status" label="审核状态" width="120"></el-table-column>
            <el-table-column prop="Bomname" label="材料名称" width="250"></el-table-column>
            <el-table-column prop="Bomsn" label="材料编号" width="180"></el-table-column>
            <el-table-column prop="Suppliername" label="供应商名称" width="250"></el-table-column>
            <el-table-column prop="Contactname" label="供应商联系人" width="250"></el-table-column>
            <el-table-column prop="Contactphone" label="供应商联系方式" width="300"></el-table-column>
            <el-table-column prop="Socialcreditcode" label="供应商社会信用代码" width="250"></el-table-column>
            <el-table-column prop="Paymentperiod" label="供应商付款周期" width="400"></el-table-column>
            <el-table-column prop="Bankname" label="供应商开户行" width="350"></el-table-column>
            <el-table-column prop="Banknumber" label="供应商账号" width="250"></el-table-column>
            <el-table-column prop="Pricetax" label="含税价" width="100"></el-table-column>
            <el-table-column prop="Pricenotax" label="未税价" width="100"></el-table-column>
            <el-table-column prop="Rate" label="税率" width="100"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyErp6SupplierProfile',
  data () {
    return {
      loading: false,
      activeName: 'first',
      // 查询
      keywords: {
        bomname: '',
        bomsn: '',
        suppliername: '',
        contactname: ''
      },
      dataList: []
    }
  },
  mounted () {
    this.apiGetErp6SupplierProfileList()
  },
  methods: {
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6SupplierProfile(url)
    },
    clicksearch () {
      this.apiGetErp6SupplierProfileList()
    },
    clickexcel () {
      this.apiExcelErp6SupplierProfile()
    },
    apiGetErp6SupplierProfileList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn,
        suppliername: that.keywords.suppliername,
        contactname: that.keywords.contactname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SupplierProfileList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiExcelImportErp6SupplierProfile: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6SupplierProfile, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetErp6SupplierProfileList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6SupplierProfile: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn,
        suppliername: that.keywords.suppliername,
        contactname: that.keywords.contactname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6SupplierProfile, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
